import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';

export default function useDraftEvents() {

  const currentUser = useUser();

  return useConnect('event.find', {
    where: {
      filter: { active: false, creatorId: currentUser.id }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });
}
